import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import themeable from 'zignal-landscape/lib/themeable';
import { ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const InteractiveIconHeader = ({
  styles,
  title = '',
  icon = ExclamationCircleOutlined,
  actionIcon = CloseCircleOutlined,
  action = noop,
  isInfo
}) => {
  const HeaderIcon = icon ? icon : ExclamationCircleOutlined;
  const InteractiveIcon = actionIcon ? actionIcon : CloseCircleOutlined;

  return (
    <div className={isInfo ? styles.panelInfoHeader : styles.panelHeader}>
      <div className={styles.panelContainer}>
        <HeaderIcon className={styles.panelIcon} />
        <span className={styles.panelTitle}>{title}</span>
        <InteractiveIcon className={styles.panelActionIcon} onClick={action} />
      </div>
    </div>
  );
};

InteractiveIconHeader.propTypes = {
  styles: PropTypes.object.isRequired,
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  actionIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  action: PropTypes.func
};

export default themeable(InteractiveIconHeader);
